import { z } from 'zod';
import { isValidSsn } from '../../utils/ssn.js';

/**
 * A US Social Security number, with or without dashes. The message never
 * repeats the value, so a validation failure can be reported without it.
 */
const ssnSchema = z
    .string()
    .refine(isValidSsn, { message: 'Enter a 9-digit Social Security number' });

export { ssnSchema };
//# sourceMappingURL=ssn.js.map
